import {DateRangeType, ID, Timestamps} from '../../global'
import subDays from 'date-fns/subDays'

export interface triggerReloadInterface {
  reloadKey: number
  triggerReload: () => void
}

export interface NamedEntity {
  id: ID
  name: string
}

export const getDefaultNamedEntity = (): NamedEntity => ({
  id: 0,
  name: '',
});

export interface Subscriber extends Timestamps {
  id: number
  first_name: string
  last_name: string
  email: string
  number: string
  note: any
  mobile: any
  country: any
  street: string
  companyName: string
  zipCode: any
  city: any
  telephone: string
  societe: string
  unsubscribed_at: any
}

export interface ChartOptions {
  series: number[]
  categoriesXAxis: string[]
}

export interface Button {
  title: string
  href: string
}

export const DEFAULT_DATE_RANGE: DateRangeType = [subDays(new Date(), 29), new Date()]

export const BREAKPOINTS = {
  MOBILE: 480,
  TABLET: 768,
} as const;
